module.exports = __webpack_public_path__ + "img/icon_img_08.33624dcd.png";